import React from 'react';
import { Link } from 'react-router-dom';

function NavBar({ authenticated, onLinkClick, onLogout }) {
  return (
    <div className="fixed top-0 left-0 right-0 h-20 text-white z-10 ">
      <ul className="flex justify-end gap-16 mr-8 text-xl mt-8 ">
        <Link to="/" onClick={() => onLinkClick('')} className='hover:bg-slate-500 duration-150 hover:text-green-400 rounded-md'>Home</Link>
        <Link to="/about" onClick={() => onLinkClick('')} className='hover:bg-slate-500 duration-150 hover:text-green-400 rounded-md'>About</Link>
        {authenticated && <Link to="/teams" onClick={() => onLinkClick('')} className='hover:bg-slate-500 duration-150 hover:text-green-400 rounded-md'>Teams</Link>}
        {authenticated ? (
          <button onClick={onLogout} className='hover:bg-slate-500 duration-150 hover:text-green-400 rounded-md'>Logout</button>
        ) : (
          <>
            <Link to="/signup" onClick={() => onLinkClick('signup')} className='hover:bg-slate-500 duration-150 hover:text-green-400 rounded-md'>Sign-up</Link>
            <Link to="/login" onClick={() => onLinkClick('login')} className='hover:bg-slate-500 duration-150 hover:text-green-400 rounded-md'>Login</Link>
          </>
        )}
      </ul>
      <h1 className='text-6xl text-center mt-8 font-extrabold'>BATTLE BOTS</h1>
    </div>
  );
}

export default NavBar;
